import type React from 'react';

import { GooglePlacesProvider } from 'src/app/shared/hooks/googlePlaces';

import { PlaceField } from './PlaceField';
import type { PlaceFieldProps } from './PlaceField';

export const PlaceFieldWrapper: React.FC<PlaceFieldProps> = (props) => {
	return (
		<GooglePlacesProvider>
			<PlaceField {...props} />
		</GooglePlacesProvider>
	);
};
